module.exports = __webpack_public_path__ + "static/media/caret-left.853f5f1a.svg";